import { Flex, ThemeProvider } from '@aircall/tractor-v2';
import { DeleteConfirmationModal } from '@components/DeleteConfirmationModalV2/DeleteConfirmationModal';
import { ModalCard } from '@components/ModalCardV2/ModalCard';
import { RolesTags } from '@components/RolesTags';
import { UserAvatar } from '@components/UserAvatarV2';
import { PendingValidationTag } from '@components/UserTag/UserTag';
import { getFullName, getInitials } from '@dashboard/library';
import { UserMinimalFragment_roles } from '@generated/UserMinimalFragment';
import { useTranslation } from 'react-i18next';

export interface AgentDeleteConfirmationModalProps {
  deleteError?: string;
  isDeleteDisabled: boolean;
  isDeleteLoading: boolean;
  isModalOpen: boolean;
  onCancelClick: () => void;
  onDeleteClick: () => void;
  idToDelete: string;
  firstNameToDelete: string;
  lastNameToDelete: string;
  pictureURLToDelete: string | null;
  rolesToDelete: UserMinimalFragment_roles[];
  isActiveToDelete: boolean;
}

export function AgentDeleteConfirmationModal({
  deleteError,
  isDeleteDisabled,
  isDeleteLoading,
  isModalOpen,
  onCancelClick,
  onDeleteClick,
  idToDelete,
  firstNameToDelete,
  lastNameToDelete,
  pictureURLToDelete,
  rolesToDelete,
  isActiveToDelete,
}: AgentDeleteConfirmationModalProps) {
  const { t } = useTranslation();

  return (
    <ThemeProvider>
      <DeleteConfirmationModal
        isModalOpen={isModalOpen}
        onCancelClick={onCancelClick}
        onDeleteClick={onDeleteClick}
        isDeleteDisabled={isDeleteDisabled}
        isDeleteLoading={isDeleteLoading}
        error={deleteError}
        confirmationText={t('users.delete_user.modal.confirmation_text')}
        bannerText={t('users.delete_user.modal.modal_banner')}
        card={
          <ModalCard
            avatar={
              <UserAvatar
                id={idToDelete}
                initials={getInitials(firstNameToDelete, lastNameToDelete)}
                src={pictureURLToDelete}
                size='large'
              />
            }
            title={getFullName(firstNameToDelete, lastNameToDelete)}
            tag={
              <Flex flexDirection='column' alignItems='center'>
                <RolesTags roles={rolesToDelete} />
                {!isActiveToDelete && <PendingValidationTag mt='xxs' />}
              </Flex>
            }
          />
        }
      />
    </ThemeProvider>
  );
}
